import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ButtonSecondary, constants, ButtonPrimary } from 'mage-deps/@klarna/bubble-ui'
import { useEducationAnalytics } from 'education-tools'
import { hooks as i18nHooks } from 'mage-i18n'
import { useHelpContext } from './hooks'

TopicList.propTypes = {
  topics: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  analyticsCategory: PropTypes.string.isRequired,
  limit: PropTypes.number
}

export default function TopicList({ topics, analyticsCategory, limit = null }) {
  const t = i18nHooks.useTranslator()

  const [isExpanded, setIsExpanded] = useState(false)

  const visibleTopicsLength = isExpanded ? topics.length : limit || topics.length

  const visibleTopics = topics.slice(0, visibleTopicsLength)

  const showExpandButton = topics.length > visibleTopics.length

  const trackExpandClick = useEducationAnalytics({
    category: 'uhqm/topic-list/expand-button',
    action: 'click'
  })

  return (
    <div>
      {visibleTopics.map((topic, index) => (
        <TopicButton
          key={topic.id}
          topic={topic}
          index={index}
          analyticsCategory={analyticsCategory}
        />
      ))}

      {showExpandButton && (
        <ButtonPrimary
          id="uhqm-topic-link"
          onClick={() => {
            trackExpandClick()
            setIsExpanded(true)
          }}
          size="small"
          white={false}
        >
          {`${t('hqm.topics.expandButton')} >>`}
        </ButtonPrimary>
      )}
    </div>
  )
}

TopicButton.propTypes = {
  topic: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  analyticsCategory: PropTypes.string.isRequired
}

function TopicButton({ topic, index, analyticsCategory }) {
  const { navigation } = useHelpContext()

  const commonAnalytics = {
    category: analyticsCategory,
    label: topic.name,
    referenceType: 'topic',
    referenceId: topic.id,
    payload: { position: index + 1 }
  }

  useEducationAnalytics({
    ...commonAnalytics,
    action: 'print',
    googleAnalytics: false,
    trackOnMount: true
  })

  const trackClick = useEducationAnalytics({
    ...commonAnalytics,
    action: 'click'
  })

  return (
    <div
      style={{
        display: 'inline-block',
        marginBottom: constants.Grid.SIZE,
        marginRight: constants.Grid.SIZE
      }}
    >
      <ButtonSecondary
        id="uhqm-topic-link"
        onClick={() => {
          trackClick()
          navigation.push('topic', { topicSlug: topic.slug })
        }}
        size="small"
      >
        {topic.name}
      </ButtonSecondary>
    </div>
  )
}
